import React, { createContext, useContext, useState } from "react";

const RedirectContext = createContext();

export const RedirectProvider = ({ children }) => {
    const [redirecting, setRedirecting] = useState(false);
    const [ userData, setUserData ] = useState([]);
    const [ config, setConfig ] = useState({});

    return (
        <RedirectContext.Provider value={{ redirecting, setRedirecting, userData, setUserData, config, setConfig}}>
            {children}
        </RedirectContext.Provider>
    );
};

export const useRedirect = () => useContext(RedirectContext);
